import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

let baseStyles = {
    container: {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    hideable: {
        position: 'relative',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.3)'
    },
    icon: {
        width: 29,
        height: 29
    },
    textIcon: {
        fontFamily: Theme.regularFont,
        color: Theme.secondaryTextColor,
        fontSize: 28
    },
    headerContainer: {
        flex: 1
    },
    controlContainer: {
        flex: 5
    },
    footerContainer: {
        flex: 1
    },
    activityIndicator: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        justifyContent: 'center'
    },
    recIcon: {
        width: 25,
        height: 25
    },
    backgroundShadow: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
    },
    backgroundTransparent: {
        backgroundColor: 'rgba(0, 0, 0, 0)'
    }
};

if (Device.isWeb) {
    baseStyles = {
        ...baseStyles,
        icon: {
            ...baseStyles.icon,
            marginLeft: 25
        }
    };
}

export default StyleSheet.create(baseStyles);
